/**
 * API Configuration
 * Centralized configuration for API endpoints that supports multiple environments
 */

// Default configuration
const DEFAULT_CONFIG = {
  API_BASE_URL: 'http://localhost:3333/api/v1',
  API_INTERNAL_BASE_URL: 'http://localhost:3333/api/v1/internal',
  API_TIMEOUT: 30000, // 30 seconds
};

// Environment-based configuration
const getApiConfig = () => {
  // Get base URL from environment variables with fallback to defaults
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || DEFAULT_CONFIG.API_BASE_URL;
  const apiInternalBaseUrl = process.env.REACT_APP_API_INTERNAL_BASE_URL || DEFAULT_CONFIG.API_INTERNAL_BASE_URL;
  const apiTimeout = parseInt(process.env.REACT_APP_API_TIMEOUT) || DEFAULT_CONFIG.API_TIMEOUT;

  return {
    API_BASE_URL: apiBaseUrl,
    API_INTERNAL_BASE_URL: apiInternalBaseUrl,
    API_TIMEOUT: apiTimeout,
    // Additional configuration based on environment
    IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
    IS_PRODUCTION: process.env.NODE_ENV === 'production',
    // Enable/disable logging based on environment
    ENABLE_API_LOGGING: process.env.REACT_APP_ENABLE_API_LOGGING === 'true' || process.env.NODE_ENV === 'development',
  };
};

// Export the configuration
export const API_CONFIG = getApiConfig();

// Export individual values for convenience
export const {
  API_BASE_URL,
  API_INTERNAL_BASE_URL,
  API_TIMEOUT,
  IS_DEVELOPMENT,
  IS_PRODUCTION,
  ENABLE_API_LOGGING,
} = API_CONFIG;

// Validation function to ensure required environment variables are set
export const validateApiConfig = () => {
  const requiredEnvVars = [
    'REACT_APP_API_BASE_URL',
  ];

  const missingVars = requiredEnvVars.filter(varName => !process.env[varName]);
  
  if (missingVars.length > 0 && IS_PRODUCTION) {
    console.warn('Missing required environment variables for production:', missingVars);
    console.warn('Using default configuration. This may cause issues in production.');
  }

  // Log current configuration in development
  if (IS_DEVELOPMENT && ENABLE_API_LOGGING) {
    console.log('API Configuration:', {
      API_BASE_URL,
      API_INTERNAL_BASE_URL,
      API_TIMEOUT,
      NODE_ENV: process.env.NODE_ENV,
    });
  }
};

// Validate configuration on import
validateApiConfig();

export default API_CONFIG;